import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
};

export const LabTestFormSlice = createSlice({
  name: "LabTestFormReducer",
  initialState,
  reducers: {
    setTestData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setTestData } = LabTestFormSlice.actions;

export default LabTestFormSlice.reducer;
